import { render, staticRenderFns } from "./AIStatusBadge.vue?vue&type=template&id=5d86601a"
import script from "./AIStatusBadge.vue?vue&type=script&lang=js"
export * from "./AIStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports